import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Rides } from '../..';
import { renderColumns } from './renderColumns';
import { renderTableHead } from './renderTableHead';
import { fetchAllHealthOrganizations } from '../../../store/health_organizations';
import { setMyFilter, setFilteredStatus, getCustomUserFilter, saveCustomUserFilter } from '../../../store/rides';
import { RIDE_STATUSES, UBER_VEHICLE_UI_ROLES } from '../../../constants/constants';

import { Navigation } from '../../../utils/navigation';
import styles from './index.module.css';

export const transofrmOrganizationsOptions = (organizations) =>
  organizations.map((h) => ({
    key: h.id,
    title: h.name,
    value: { id: h.id, name: h.name },
  }));

const ENT_Rides = ({

  getCustomUserFilter, savedFilterParams,
  fetchAllHealthOrganizations,
  hasSavedFilterParams,
  healthOrganizations,
  setMyFilter,
  setFilteredStatus,
  isUberEligibleFromAuth,
  role,
  userRole,
}) => {
  const hasFetchedOrganizationsRef = useRef(false);
  const hasFetchedFilterRef = useRef(false);
  const isUberEligible = isUberEligibleFromAuth;
  
  const navigate = Navigation();
  const setRequestsOnly = useCallback(() => {
    setMyFilter({ status: [RIDE_STATUSES.IN_PROGRESS] });
    setFilteredStatus(true);
  }, [setMyFilter, setFilteredStatus]);

  useEffect(() => {
    return () => setFilteredStatus(false);
  }, [setFilteredStatus]);

  useEffect(() => {
    if (hasFetchedOrganizationsRef.current) return;
    hasFetchedOrganizationsRef.current = true;
    fetchAllHealthOrganizations();
    return () => { };
  }, [fetchAllHealthOrganizations]);

  useEffect(() => {
    if (hasFetchedFilterRef.current) return;
    hasFetchedFilterRef.current = true;
    getCustomUserFilter();

    return () => { };
  }, [getCustomUserFilter]);

  const ridesTable = useMemo(
    () => (
      <div className={styles.table}>
        <Rides
          setRequestsOnly={setRequestsOnly}
          savedFilterParams={savedFilterParams}
          hasSavedFilterParams={hasSavedFilterParams}
          columns={renderColumns(navigate)}
          renderTableHead={renderTableHead({
            healthOrganizations: transofrmOrganizationsOptions(healthOrganizations),
            isUberEligible,
          })}
        />
      </div>
    ),
    [hasSavedFilterParams, healthOrganizations, setRequestsOnly, savedFilterParams, navigate, isUberEligible],
  );
  return ridesTable;
};

const mapStateToProps = (state) => ({
  healthOrganizations: state.healthOrganizations.healthOrganizations,
  savedFilterParams: state.rides?.savedFilterParams,
  hasSavedFilterParams: state.rides?.savedFilterParams && Boolean(Object.keys(state.rides?.savedFilterParams)?.length),
  isUberEligibleFromAuth: state.authorization?.isUberEligible,
  role: state.authorization?.role,
  userRole: state.authorization?.user?.role,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {

      setMyFilter,
      fetchAllHealthOrganizations,
      setFilteredStatus,
      getCustomUserFilter,
      saveCustomUserFilter,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(ENT_Rides);
